import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const NewXIcon = ({ color = '#000000', size = 20, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2726 1.58691H18.0838L11.9421 8.60649L19.1673 18.1586H13.51L9.07901 12.3653L4.00894 18.1586H1.19601L7.76518 10.6503L0.833984 1.58691H6.63491L10.6401 6.88219L15.2726 1.58691ZM14.2859 16.4759H15.8436L5.78848 3.18119H4.11687L14.2859 16.4759Z" fill={color} />
  </svg>

);

export default NewXIcon;